"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _radio = _interopRequireDefault(require("antd/lib/radio"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _reactCircularProgressbar = require("react-circular-progressbar");

require("react-circular-progressbar/dist/styles.css");

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

require("./coverImageEditor.scss");

var _AntdIcon = _interopRequireDefault(require("../../antdIcon/AntdIcon"));

var _api = _interopRequireDefault(require("../../../redux/api"));

class CoverImageEditor extends _react.default.Component {
  constructor() {
    super(...arguments);
    this.state = {
      isCoverUploading: false,
      uploadPercentComplete: 0
    };

    this.updateProgress = progressEvent => {
      const uploadPercentComplete = progressEvent.lengthComputable ? Math.round(100 * (progressEvent.loaded / progressEvent.total)) : 0;
      this.setState({
        uploadPercentComplete
      });
    };

    this.onDrop = files => {
      if (files && files.length === 1) {
        const file = files[0];
        const formData = new FormData();
        formData.append('file', file);
        this.setState({
          isCoverUploading: true,
          uploadPercentComplete: 0
        }); // TODO I should really separate out the upload from the component, but 1) make it work.

        _api.default.post('/a/cms/uploads/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: this.updateProgress,
          timeout: 100000
        }).then(res => {
          var _a;

          if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.link) {
            if (this.props.coverImageChangeHandler) {
              this.props.coverImageChangeHandler(res.data.link);
            }

            this.setState({
              isCoverUploading: false
            });
          } else {
            this.setState({
              isCoverUploading: false
            });
          }
        }).catch(err => {
          this.setState({
            isCoverUploading: false
          });
        });
      }
    };

    this.coverImageChangeHandler = event => {
      const {
        value
      } = event.target;
      this.props.coverImageChangeHandler(value);
    };
  }

  render() {
    const {
      currentCoverImageUrl,
      coverImageUrlChoices
    } = this.props;
    const {
      isCoverUploading,
      uploadPercentComplete
    } = this.state;

    const renderDropzone = (isDragActive, isDragAccept, isDragReject) => {
      if (isCoverUploading) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-cover-image-editor-dropzone-active"
        }, /*#__PURE__*/_react.default.createElement(_reactCircularProgressbar.CircularProgressbar, {
          value: uploadPercentComplete,
          text: `${uploadPercentComplete}%`
        }));
      }

      if (isDragAccept) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-cover-image-editor-dropzone-accept"
        }, "Drop files now");
      }

      if (isDragReject) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-cover-image-editor-dropzone-reject"
        }, "Reject Drag");
      }

      if (isDragActive) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-cover-image-editor-dropzone-active"
        }, "Drop files here...");
      }

      if (currentCoverImageUrl === '') {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "hmp-cover-image-editor-dropzone-inactive"
        }, /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
          fontAwesomeIcon: _proSolidSvgIcons.faCloudUpload
        }), /*#__PURE__*/_react.default.createElement("span", null, "Click or Drag & Drop to"), /*#__PURE__*/_react.default.createElement("span", null, "Upload"));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "hmp-cover-image-editor-dropzone-inactive"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: currentCoverImageUrl,
        alt: "Cover Image"
      }));
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-cover-image-editor"
    }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
      accept: ['image/jpeg', 'image/png', 'image/gif'],
      multiple: false,
      onDrop: this.onDrop,
      preventDropOnDocument: true
    }, ({
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject
    }) => /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-cover-image-editor-dropzone-container"
    }, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, getRootProps({
      className: 'hmp-cover-image-editor-dropzone'
    })), /*#__PURE__*/_react.default.createElement("input", Object.assign({}, getInputProps())), renderDropzone(isDragActive, isDragAccept, isDragReject)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-cover-image-editor-image-list"
    }, /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
      value: currentCoverImageUrl,
      onChange: this.coverImageChangeHandler
    }, /*#__PURE__*/_react.default.createElement(_radio.default, {
      className: "hmp-cover-image-editor-choice",
      value: ""
    }, "None"), coverImageUrlChoices && coverImageUrlChoices.map(imageUrl => {
      return /*#__PURE__*/_react.default.createElement(_radio.default, {
        value: imageUrl,
        key: `choice-${imageUrl}`,
        className: "hmp-cover-image-editor-choice"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: imageUrl,
        alt: imageUrl
      }));
    }))));
  }

}

var _default = CoverImageEditor;
exports.default = _default;